function ajaxSearch(url, params) {
  $.ajax({ url: url, data: params, dataType: 'script' })
}

$(document).on('submit', '.search-form[data-remote="true"]', function (e) {
  e.preventDefault()
  ajaxSearch($(this).attr('action'), { search: $(this).find('[name=search]').val() })
})

$(document).on('input', '.js-input-search', function () {
  clearTimeout(this.searchCallbackTime)
  var input = this
  this.searchCallbackTime = setTimeout(function () {
    $(input).closest('form').trigger('submit')
  }, 300)
})

$(document).on('click', '.pagination__button', function (e) {
  e.preventDefault()
  ajaxSearch($(this).attr('href'), {})
})
